module.exports = __webpack_public_path__ + "static/media/preview@768.5671f5d0.png";